import { type PropsWithChildren } from "react"
import {
    Button,
    type ButtonProps,
    Container,
    DropdownTrigger,
    Stack,
    Typography,
    useCoralDropdown,
} from "@octopus-energy/coral/atoms"

function MenuDropdownButton({ children, ...props }: PropsWithChildren<ButtonProps>) {
    const { closeDropdown } = useCoralDropdown()

    return (
        <Button
            variant="ghost"
            color="secondary500"
            size="small"
            onClick={closeDropdown}
            {...props}
        >
            <Stack fullWidth>
                <Typography
                    color="inherit"
                    component="span"
                    textAlign="left"
                    textStyle="h6"
                >
                    {children}
                </Typography>
            </Stack>
        </Button>
    )
}

type MenuDropdownTriggerProps = PropsWithChildren

function MenuDropdownTrigger({ children }: MenuDropdownTriggerProps) {
    return (
        <DropdownTrigger asChild>
            <Container minWidth="max-content">{children}</Container>
        </DropdownTrigger>
    )
}

export const MenuDropdown = {
    Button: MenuDropdownButton,
    Trigger: MenuDropdownTrigger,
}
